import { AlertTriangle } from 'lucide-react';

import { useMe } from '@/hooks/use-me';

const DEMO_BESS_CONFIG_ID = '49';
const NEW_PLATFORM_URL = 'https://accure-cloud.com/demobess/';

export function DeprecationBanner() {
  const me = useMe();

  if (me.config.id !== DEMO_BESS_CONFIG_ID) {
    return null;
  }

  return (
    <div
      data-testid="deprecation-banner"
      className="flex items-center justify-center gap-2 border-b border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-900"
    >
      <AlertTriangle className="size-4 shrink-0 text-amber-600" />
      <span>
        This platform is deprecated for demo purposes.{' '}
        <a
          href={NEW_PLATFORM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium underline hover:text-amber-700"
        >
          Use the new platform
        </a>
        .
      </span>
    </div>
  );
}
